<div class="container__card d-flex justify-center align-center">
  <ng-container *ngFor="let contract of contractList; let index = index">
    <div class="card mt-8 mb-5">
      <div
        class="card__header d-flex align-center justify-space-between ptb-8 plr-12"
      >
        <span class="card__header__number" [title]="contract?.ContractId"
          ><strong></strong> {{ contract?.Number || 0 }}</span
        >
        <span
          class="card__header__status"
          [ngClass]="{
            reversed:
              contract?.Status?.toLowerCase() === 'a estornar' ||
              contract?.Status?.toLowerCase() === 'estornar' ||
              contract?.Status?.toLowerCase() === 'estornado parcial'
          }"
          >{{ contract?.Status | titlecase }}</span
        >
      </div>
      <div class="card__body d-flex plr-10">
        <div
          class="card__body__left vw-50 d-flex direction-column align-start justify-space-around"
        >
          <span
            ><strong>Banco:</strong><br />{{
              contract?.FinancialInstitution || "-"
            }}</span
          >
          <span
            ><strong>Canal de venda:</strong><br />{{
              contract?.Chanel || "-"
            }}</span
          >
          <span
            ><strong>Comissão:</strong><br />{{
              contract?.InvoiceAmount | currency : "BRL"
            }}</span
          >
          <!--Descomentar para resolver erro no console.-->
          <!--<span>
            <strong>Comissão:</strong><br />
            {{
              contract && contract.InvoiceAmount ?
                (contract.InvoiceAmount.toString().replace(',', '.') | currency : 'BRL') :
                '-'
            }}
          </span>-->
        </div>
        <div
          class="card__body__right vw-50 d-flex direction-column align-start justify-space-around"
        >
          <span
            ><strong>Dt.Produção:</strong><br />{{
              contract?.ProductionDate | date : "shortDate"
            }}</span
          >
          <span
            ><strong>Cliente:</strong><br />{{ contract?.Client || "-" }}</span
          >
          <span
            ><strong>Valor Fin.:</strong><br />{{
              (contract?.Amount | currency : "BRL") || "-"
            }}</span
          >
        </div>
      </div>
      <div
        class="card__footer vw-100 d-flex align-center justify-space-between plr-15"
      >
        <a role="button" tabindex="0" (click)="openDetailsDialog(contract)"
          (keydown.enter)="openDetailsDialog(contract)" (keydown.space)="openDetailsDialog(contract)"><span>Visualizar</span></a>
        <button class="btn-icon" (click)="deleteContract(contract)">
          <app-svg-icon
            src="assets/icons/trash-solid-icon.svg"
            width="17px"
            height="18px"
            color="dangerRed"
          ></app-svg-icon>
        </button>
      </div>
    </div>
  </ng-container>
</div>
